// extracted by mini-css-extract-plugin
export default {"borderless":"change-logs_borderless__h+Gie"};